<template>
    <v-layout justify-center>
        <v-responsive max-width="1024" width="100%" height="100%" class="shop-product-view">
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12">
                    <div class="headline text-start">회원 상세</div>
                </v-col>
                <v-col class="pa-2" cols="12" v-if="user.type == USER_TYPES.OPERATOR.value">
                    <view-section-card title="관리자 정보">
                        <v-card-text>
                            <v-row class="ma-n2">
                                <v-col class="pa-2" cols="12" sm="">
                                    <v-text-field v-model="user.name" v-bind="attrs_input" label="이름" />
                                </v-col>
                                <v-col class="pa-2" cols="12" sm="">
                                    <v-text-field v-model="user.password" v-bind="attrs_input" label="비밀번호 변경" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </view-section-card>
                </v-col>
                <v-col class="pa-2" cols="12" v-if="user.type == USER_TYPES.CONSUMER.value">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="12" lg="8">
                            <view-section-card title="회사 정보">
                                <v-card-text>
                                    <v-row class="ma-n2">
                                        <v-col class="pa-2" cols="12" sm="">
                                            <v-row class="ma-n2">
                                                <v-col class="pa-2" cols="12">
                                                    <v-row class="ma-n2">
                                                        <v-col class="pa-2" cols="12">
                                                            <v-text-field v-model="user.name" v-bind="attrs_input" label="회사명" />
                                                        </v-col>
                                                        <v-col class="pa-2" cols="12">
                                                            <v-text-field v-model="user.business.number" v-bind="attrs_input" label="사업자 번호" />
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col class="pa-2" cols="12">
                                                    <v-row class="ma-n2">
                                                        <v-col class="pa-2" cols="12">
                                                            <v-text-field v-model="user.business.type" v-bind="attrs_input" label="업태, 업종" />
                                                        </v-col>
                                                        <v-col class="pa-2" cols="12">
                                                            <v-text-field v-model="user.business.email" v-bind="attrs_input" label="세금계산서 발행 이메일" />
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col class="pa-2" cols="12" sm="auto">
                                            <v-card outlined style="overflow: hidden">
                                                <image-popup :src="user?.business?.cert?.url" :attrs_avatar="{ size: $vuetify?.breakpoint?.width < 600 ? '100%' : '206' }" />
                                            </v-card>
                                        </v-col>

                                        <v-col class="pa-2" cols="12">
                                            <v-row class="ma-n2">
                                                <v-col class="pa-2" cols="12" sm="2" lg="12">
                                                    <v-text-field v-model="user.postcode" label="우편번호" v-bind="attrs_input" />
                                                </v-col>
                                                <v-col class="pa-2" cols="12" sm="" lg="12">
                                                    <v-text-field v-model="user.address1" label="기본주소" v-bind="attrs_input" />
                                                </v-col>
                                                <v-col class="pa-2" cols="12" sm="" lg="12">
                                                    <v-text-field v-model="user.address2" label="상세주소" v-bind="attrs_input" />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </view-section-card>
                        </v-col>
                        <v-col class="pa-2" cols="12" lg="4">
                            <v-row class="ma-n2">
                                <v-col class="pa-2" cols="12">
                                    <view-section-card title="담당자 정보">
                                        <v-card-text>
                                            <v-row class="ma-n2">
                                                <v-col class="pa-2" cols="12" sm="" lg="12">
                                                    <v-text-field v-model="user.business.worker" v-bind="attrs_input" label="담당자 이름" />
                                                </v-col>
                                                <v-col class="pa-2" cols="12" sm="" lg="12">
                                                    <v-text-field v-model="user.phone" v-bind="attrs_input" label="담당자 연락처" />
                                                </v-col>
                                                <v-col class="pa-2" cols="12" sm="" lg="12">
                                                    <v-text-field v-model="user.email" v-bind="attrs_input" label="담당자 이메일" />
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </view-section-card>
                                </v-col>
                                <v-col class="pa-2" cols="12">
                                    <v-row class="ma-n2">
                                        <v-col class="pa-2" cols="12">
                                            <view-section-card title="비밀번호 변경" hide-divider>
                                                <template #actions>
                                                    <v-text-field v-model="user.password" v-bind="attrs_input" />
                                                </template>
                                            </view-section-card>
                                        </v-col>
                                        <v-col class="pa-2" cols="12" sm="" lg="12">
                                            <view-section-card title="주의회원" hide-divider>
                                                <template #actions>
                                                    <v-switch v-model="user.isWarning" v-bind="attrs_switch" color="red lighten-1" />
                                                </template>
                                            </view-section-card>
                                        </v-col>
                                        <v-col class="pa-2" cols="12" sm="" lg="12">
                                            <view-section-card title="회원승인" hide-divider>
                                                <template #actions>
                                                    <v-switch v-model="user.isApproved" v-bind="attrs_switch" color="primary" />
                                                </template>
                                            </view-section-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-row justify="center" no-gutters>
                        <v-col md="auto" sm="auto">
                            <v-btn color="primary" :disabled="['uxidev', 'admin'].includes(user.username)" @click="save">저장</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pa-2" cols="12" v-if="user.type == USER_TYPES.CONSUMER.value">
                    <v-data-table v-bind="{ items, headers }" class="v-sheet--outlined">
                        <template #top>
                            <v-card-title class="subtitle-2 font-weight-bold">주문내역</v-card-title>
                            <v-divider />
                        </template>
                        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                        <template #[`item.numbers`]="{ item }">
                            <div>
                                <order-view :_order="item._order">
                                    <template #activator="{ attrs, on }">
                                        <v-btn x-small text tile class="pa-0 caption" v-bind="attrs" v-on="on">{{ item.order?.orderNo }}</v-btn>
                                    </template>
                                </order-view>
                            </div>
                            <div>{{ item.purchaseNo }}</div>
                        </template>
                        <template #[`item.order.sender`]="{ item }">
                            <div>{{ item.order.sender.name }}</div>
                            <div>{{ item.order.sender.phone }}</div>
                            <div>{{ item.order.sender.email }}</div>
                        </template>
                        <template #[`item.order.receiver`]="{ item }">
                            <div>{{ item.order.receiver.name }}</div>
                            <div>{{ item.order.receiver.phone }}</div>
                            <div>{{ item.order.receiver.email }}</div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch, USER_TYPES } from "@/assets/variables";

import ImagePopup from "@/components/console/dumb/image-popup.vue";
import OrderView from "@/components/console/shop/purchases/order-view/order-view.vue";
import ViewSectionCard from "@/components/console/dumb/view-section-card.vue";
import ViewFieldCard from "@/components/console/dumb/view-field-card.vue";

const headers = [
    { width: 190, divider: true, text: "주문번호\n상품주문번호", value: "numbers", class: "white-space-pre-line" },
    { width: 100, divider: true, text: "주문일자", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value || "-" },
    { width: 100, divider: true, text: "주문상태", value: "orderStatusMessage" },
    { width: 120, divider: true, text: "클레임상태", value: "claimStatusMessage" },
    { width: 120, divider: true, text: "연락처", value: "order.sender.phone" },
    { width: 200, divider: true, text: "구매상품", value: "product.name" },
    { width: 200, divider: true, text: "옵션정보", value: "name" },
    { width: 100, divider: true, text: "구매수량", value: "amount" },
    { width: 120, divider: true, text: "구매자", value: "order.sender" },
    { width: 120, text: "수취인", value: "order.receiver" },
].map((item) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), cellClass: "caption" }));

export default {
    components: {
        ImagePopup,
        OrderView,
        ViewSectionCard,
        ViewFieldCard,
    },
    setup: () => ({
        headers,
        attrs_input,
        attrs_switch,
        USER_TYPES,
    }),
    data: () => ({
        user: {},
        levels: [],

        purchases: [],
    }),
    computed: {
        items() {
            return [...this.purchases];
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { user } = await api.console.users.get({ _id: this.$route.params._user });
                this.user = user;

                var { levels } = await api.console.levels.getLevels();
                this.levels = levels;

                var { purchases } = await api.console.shop.purchases.getPurchases({
                    params: { _user: this.$route.params._user },
                });

                this.purchases = purchases;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async save() {
            try {
                await api.console.users.put(this.user);

                alert("수정되었습니다");
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>
